export default {
  visa: "Visa",
  mastercard: "MasterCard",
  american_express: "American Express",
  hipercard: "Hipercard",
  elo: "elo",
  hiper: "hiper",
  discover: "Discover",
  diners_club: "Diners Club",
  jcb: "JCB",
  cabal: "Cabal",
  union_pay: "UnionPay",
  mais: "Mais",
  coopercard: "Coopercard",
  sorocred: "Sorocred",
  banescard: "BanesCard",
  credz: "Credz",
  ticket: "Ticket",
  sodexo: "Sodexo",
  vr: "VR",
  greencard: "Greencard",
  verocheque: "Verocheque",
  up_plan: "Up Plan",
  nutricash: "Nutricash",
  bnb_clube: "BNB Clube",
  alelo: "alelo",
  valecard: "Valecard",
  aura: "Aura",
  goodcard: "Good Card",
  policard: "Policard",
  rede_compras: "Rede Compras",
  maxx_van: "Maxx Van"
};



// WEBPACK FOOTER //
// ./src/core/enum/network-names.enum.js